interface SourcesBodySectionProps {
  className?: string;
  title?: string;
  body: string;
  list?: string[];
}

export default function SavingsSourcesBodySection({
  className,
  title,
  body,
  list,
}: SourcesBodySectionProps) {
  return (
    <div className={className}>
      {title ? <span className="body2-strong block">{title}:</span> : null}
      <span className="body2 block">{body}</span>
      {list ? (
        <ul className="mt-[16px]">
          {list.map((listItem) => (
            <li key={listItem} className="body2">
              {listItem}
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
